import * as t from "io-ts";
import "reflect-metadata";
import { ContainerAlert, ContainerAlertEntity } from "./container-alert";
import { SiteAlert, SiteAlertEntity } from "./site-alert";
import { DatabaseCode, toDatabaseCode } from "./database-code";

/** Validator for a system alert type. */
export const SystemAlertBaseValidator = t.type({
  systemAlertId: t.string,
  systemAlertType: t.string,
  systemAlertDttm: t.number,
});

export type SystemAlert = t.TypeOf<typeof SystemAlertBaseValidator> &
  (ContainerAlert | SiteAlert);

export interface SystemAlertEntity {
  getSystemAlertId: () => string;
  getSystemAlertType: () => SystemAlertType;
  getSystemAlertDate: () => Date | undefined;
}

export interface SystemAlertType extends DatabaseCode {}

const containerAlert: SystemAlertType = {
  code: 'CONTAINER_ALERT',
  displayValue: {
    id: 'ots.ui.entity.alert.type.container',
    defaultMessage: 'Container Alert',
  },
};

const siteAlert: SystemAlertType = {
  code: 'SITE_ALERT',
  displayValue: {
    id: 'ots.ui.entity.alert.type.site',
    defaultMessage: 'Site Alert',
  },
};

export const systemAlertType = {
  containerAlert,
  siteAlert,
};

export const systemAlertTypes = Object.values(systemAlertType)

/**
 * Return the system alert type by code value.
 *
 * @param code the code value
 * @returns the system alert type
 */
export const toSystemAlertType = (code: string): SystemAlertType => toDatabaseCode(code, systemAlertTypes)

export const isContainerAlert = (
  alert: SystemAlert
): alert is ContainerAlert => {
  return alert.alertType === systemAlertType.containerAlert.code;
};

export const isContainerAlertEntity = (
  alert: SystemAlertEntity
): alert is ContainerAlertEntity => {
  return alert.getSystemAlertType() === systemAlertType.containerAlert;
};

export const isSiteAlert = (alert: SystemAlert): alert is SiteAlert => {
  return alert.alertType === systemAlertType.siteAlert.code;
};

export const isSiteAlertEntity = (
  alert: SystemAlertEntity
): alert is SiteAlertEntity => {
  return alert.getSystemAlertType() === systemAlertType.siteAlert;
};
